import { alert, defaultErrorMsg } from '../../../../helpers/rsuite/Alerts';
import { asyncService } from '../../../../helpers/AsyncService';
import { cuotitasStoreService } from '../../../../services';
import { dateFns, FormatPhone, validator, sortAlphabetically, retryService, errorInput } from '../../../../helpers';
import { errorMapper, getDataError } from '../../../../helpers/ErrorMappers';
import { Field, CellPhoneField, PhoneField, CurrencyField, errorPlacementData } from '../../../../helpers/rsuite/Form';
import { Form, Schema, Radio, RadioGroup, SelectPicker, DatePicker, Modal, Button, Grid, Row, Col } from 'rsuite';
import { STEPS } from '../../../../constants/loanevents/steps';
import ButtonSMS from '../../../../helpers/ButtonSMS';
import React, { useMemo } from 'react';
import ENABLE from '../../../../constants/enable';

// Address data
const provinces = require('../../../../constants/loans/provinces.json').sort((provinceA, provinceB) => sortAlphabetically(provinceA.descripcion, provinceB.descripcion));
const departments = require('../../../../constants/loans/departments.json').sort((departmentA, departmentB) => sortAlphabetically(departmentA.descripcion, departmentB.descripcion));
const localities = require('../../../../constants/loans/localities.json').sort((localityA, localityB) => sortAlphabetically(localityA.descripcion, localityB.descripcion));

function getAge (date) {
    var today = new Date();
    var birthDate = new Date(date);
    var age = today.getFullYear() - birthDate.getFullYear();
    var month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    };
    return age;
}

// Form validation
const required = 'Este campo es requerido.';
const msgEmail = 'Por favor ingrese un correo electrónico valido.';
const msgNumber = 'Por favor, ingrese un número valido.';

const { NumberType, StringType, BooleanType } = Schema.Types;

const model = Schema.Model({
    firstName: StringType()
        .isRequired(required),
    lastName: StringType()
        .isRequired(required),
    validateTelephone: NumberType(msgNumber)
        .addRule((value) => (value?.length === 4), 'Por favor, ingrese un código de cuatro digitos')
        .isRequired(required),
    email: StringType()
        .isEmail(msgEmail),
    cellPhoneAreaCode: NumberType(msgNumber)
        .addRule((value) => (value?.length <= 4), 'Por favor, ingrese un código de teléfono valido')
        .isRequired(required),
    cellPhoneCharacteristic: NumberType(msgNumber)
        .addRule((value, data) => (value?.length <= 4), 'Por favor, ingrese una característica de teléfono valida')
        .isRequired(required),
    cellPhoneNumber: NumberType(msgNumber)
        .addRule((value, data) => (value?.length === 4), 'Por favor, ingrese una número de teléfono valido')
        .isRequired(required),
    additionalPhoneAreaCode: NumberType(msgNumber)
        .addRule((value, data) => (value?.length <= 4), 'Por favor, ingrese un código de teléfono valido'),
    additionalPhoneCharacteristic: NumberType(msgNumber)
        .addRule((value, data) => (value?.length <= 4), 'Por favor, ingrese una característica de teléfono valida'),
    additionalPhoneNumber: NumberType(msgNumber)
        .addRule((value, data) => (value?.length === 4), 'Por favor, ingrese una número de teléfono valido'),
    bornDate: Schema.Types.DateType()
        .addRule((value, data) => { const age = getAge(value); return (age >= 18 && age <= 84); }, 'Por favor, ingrese una fecha permitida (edad).')
        .isRequired(required),
    document: NumberType(msgNumber)
        .addRule((value, data) => (validator.isDNI(value + '')), 'Por favor, ingrese un DNI valido (8 dígitos)')
        .isRequired(required),
    amount: NumberType(msgNumber)
        .addRule((value, data) => (value * 1 > 0), 'Ingrese un monto mayor a cero')
        .isRequired(required),
    activity: NumberType(msgNumber)
        .addRule((value, data) => (value * 1 > 0), required)
        .isRequired(required),
    province: NumberType(msgNumber)
        .addRule((value, data) => (value * 1 > 0), required)
        .isRequired(required),
    department: NumberType(msgNumber)
        .addRule((value, data) => (value * 1 > 0), required)
        .isRequired(required),
    location: NumberType(msgNumber)
        .addRule((value, data) => (value * 1 > 0), required)
        .isRequired(required),
    postcode: NumberType(msgNumber)
        .addRule((value) => (value * 1 > 0), msgNumber)
        .isRequired(required),
    street: StringType()
        .isRequired(required),
    number: StringType()
        .isRequired(required),
    floor: NumberType(msgNumber),
    apartment: StringType(),
    'reference-firstName': StringType()
        .isRequired(required),
    'reference-lastName': StringType()
        .isRequired(required),
    'reference-relation': StringType()
        .isRequired(required),
    'reference-isCellPhone': BooleanType()
        .isRequired(required),
    'reference-phoneAreaCode': NumberType(msgNumber)
        .addRule((value, data) => (value?.length <= 4), 'Por favor, ingrese un código de teléfono valido')
        .isRequired(required),
    'reference-phoneCharacteristic': NumberType(msgNumber)
        .addRule((value, data) => (value?.length <= 4), 'Por favor, ingrese una característica de teléfono valida')
        .isRequired(required),
    'reference-phoneNumber': NumberType(msgNumber)
        .addRule((value, data) => (value?.length === 4), 'Por favor, ingrese una número de teléfono valido')
        .isRequired(required),
});

const body0 = {
    width: '540px',
    padding: '0 4px'
};

const hr = {
    marginTop: '0',
    borderTop: 'none'
};

export function ModifyPersonStep (context) {
    // global dialog state

    const idStore = context.idStore;
    const notification = context.notification;
    const activities = context.activities;
    const formMainUser = context.formMainUser;
    const formInstallments = context.formInstallments;
    const formErrorMainUser = context.formErrorMainUser;
    const formRef = context.formRef;

    const isAllowContinue = context.isAllowContinue;
    const isLoading = context.isLoading;
    const isAllowBack = context.isAllowBack;
    const isTokenValidated = context.isTokenValidated;

    const setIsLoading = context.setIsLoading;
    const setFormMainUser = context.setFormMainUser;
    const setIsAllowContinue = context.setIsAllowContinue;
    const setIsAllowBack = context.setIsAllowBack;
    const setNotification = context.setNotification;
    const setFormErrorMainUser = context.setFormErrorMainUser;
    const setSign = context.setSign;
    const setIsTokenValidated = context.setIsTokenValidated;

    const submitToast = context.submitToast;
    const nextStep = context.nextStep;
    const back = context.back;

    // hooks

    const telephone = useMemo(() => {
        return `${formMainUser.cellPhoneAreaCode}${formMainUser.cellPhoneCharacteristic}${formMainUser.cellPhoneNumber}`;
    }, [formMainUser.cellPhoneAreaCode, formMainUser.cellPhoneCharacteristic, formMainUser.cellPhoneNumber]);

    const isDisabled = useMemo(() => {
        return !formMainUser.validateTelephone.length;
    }, [formMainUser.validateTelephone]);

    const validDepartments = useMemo(() => {
        return departments.filter(department => department?.idProvincia === formMainUser.province);
    }, [formMainUser.province]);

    const validLocalities = useMemo(() => {
        return localities.filter(location => location?.idPartido === formMainUser.department);
    }, [formMainUser.department]);

    // actions

    async function submit () {
        // validate form

        if (telephone.length !== 10) {
            scrollToPhoneOnError();
            alert('error', 'Número de telefono celular invalido, este debe tener diez dígitos.');
            return;
        }

        if (!formRef.current.check()) {
            console.error('Form Error');
            return;
        }

        // validate token
        if (!isTokenValidated) {
            try {
                setIsLoading(true);

                const token = formMainUser.validateTelephone;
                const data = {
                    token: token,
                    idExternal: formMainUser.id,
                };

                const res = await cuotitasStoreService.validateToken(data);

                if (res.telephone !== FormatPhone(telephone)) {
                    alert('error', 'El teléfono fue modificado, presione Enviar código para validar el teléfono ingresado.');
                    return setFormMainUser({ ...formMainUser, validateTelephone: '' });
                }

                if (idStore !== res?.metadata?.idStore) {
                    throw new Error('Código incorrecto');
                }
            }
            catch (error) {
                const dataError = error?.response?.data;
                const OTPAttempts = dataError.extra.attemptsAvailable;

                if (OTPAttempts > 0) {
                    return OTPAttempts > 1
                        ? alert('error', `Código incorrecto. Quedan ${OTPAttempts} intentos.`)
                        : alert('error', `Código incorrecto. Queda ${OTPAttempts} intento.`);
                }

                alert('error', 'Código invalidado, por favor reenvíe el sms para obtener uno nuevo.');

                return setFormMainUser({ ...formMainUser, validateTelephone: '' });
            }
            finally {
                setIsLoading(false);
            }
        }

        // update loan person

        try {
            setIsLoading(true);

            const form = {
                id: formMainUser.id, // id external person
                step: STEPS.PERSON_COMPLETION,
                firstName: formMainUser.firstName,
                lastName: formMainUser.lastName,
                document: formMainUser.document + '',
                gender: formMainUser.gender,
                email: formMainUser.email,
                bornDate: formMainUser.bornDate,
                cellPhoneAreaCode: formMainUser.cellPhoneAreaCode,
                cellPhoneCharacteristic: formMainUser.cellPhoneCharacteristic,
                cellPhoneNumber: formMainUser.cellPhoneNumber,
                additionalPhoneAreaCode: formMainUser.additionalPhoneAreaCode,
                additionalPhoneCharacteristic: formMainUser.additionalPhoneCharacteristic,
                additionalPhoneNumber: formMainUser.additionalPhoneNumber,
                address: {
                    idProvince: formMainUser.province,
                    idLocality: formMainUser.location,
                    postcode: formMainUser.postcode,
                    street: formMainUser.street,
                    number: formMainUser.number,
                    floor: formMainUser.floor,
                    apartment: formMainUser.apartment
                },
                reference: {
                    firstName: formMainUser['reference-firstName'],
                    lastName: formMainUser['reference-lastName'],
                    relation: formMainUser['reference-relation'],
                    isCellPhone: formMainUser['reference-isCellPhone'],
                    telephoneAreaCode: formMainUser['reference-phoneAreaCode'],
                    telephoneCharacteristic: formMainUser['reference-phoneCharacteristic'],
                    telephoneNumber: formMainUser['reference-phoneNumber']
                },
                monthlyAmount: formMainUser.amount,
                idActivity: parseInt(formMainUser.activity)
            };

            await asyncService((qss) => cuotitasStoreService.createOrModifyUser(form, qss));
        }
        catch (error) {
            console.error(error);
            const msg = errorMapper(error);
            // The loan flow cannot continue if the following conditions are met
            if (msg?.description === 'Provider returned invalid state') {
                setIsAllowContinue(false);
                setIsAllowBack(false);
            }

            error.msg = msg;
            setIsTokenValidated(false);
            return alert(msg?.type, msg?.message, 0, 'topCenter', () => submitToast(error));
        }
        finally {
            setIsLoading(false);
        }

        // create sign request

        try {
            setIsLoading(true);
            const installment = ENABLE?.enableInstallmentsWithDate ? JSON.parse(formInstallments.installments) : { installments: formInstallments.installments };
            const assistanceMapping = JSON.parse(localStorage.getItem('assistance')) || {};
            const idCommercialPlan = installment?.idCommercialPlan || 0;
            const assistance = assistanceMapping[idCommercialPlan] || 0;

            const data = {
                amount: formInstallments.amount * 1,
                installments: installment?.installments,
                firstExpirationDate: installment?.firstExpirationDate,
                id_loan_offer: formInstallments.id_loan_offer,
                idCommercialPlan: idCommercialPlan,
                assistance: assistance,
                person: {
                    idType: 1,
                    attributes: [
                        {
                            description: 'first_name',
                            value: formMainUser.firstName
                        },
                        {
                            description: 'last_name',
                            value: formMainUser.lastName
                        },
                        {
                            description: 'gender',
                            value: formMainUser.gender.toUpperCase()
                        }
                    ],
                    documents: [
                        {
                            idType: 1,
                            document: formMainUser.document
                        }
                    ]
                }
            };

            const sign = await asyncService((qs) => cuotitasStoreService.createLoanAndSign(idStore, data, qs));

            nextStep(5);
            return setSign(sign);
        }
        catch (error) {
            console.error(error);
            const msg = errorMapper(error);
            // The loan flow cannot continue if the following conditions are met
            if (msg?.description === 'Provider returned invalid state') {
                context.setIsAllowContinue(false);
                context.setIsAllowBack(false);
            }

            if (msg.message === defaultErrorMsg) {
                setIsTokenValidated(true);
                return alert('error', 'Se produjo un error en la creación de la firma, por favor vuelva a intentar. Si el problema persiste:', 0, 'topCenter', () => submitToast(error));
            }

            error.msg = msg;
            setIsTokenValidated(true);
            return alert(msg?.type, msg?.message, 0, 'topCenter', () => context.submitToast(error));
        }
        finally {
            setIsLoading(false);
        }
    };

    async function sendOTP () {
        try {
            const telephone = (formMainUser.cellPhoneAreaCode * 1) + formMainUser.cellPhoneCharacteristic + formMainUser.cellPhoneNumber;
            const data = {
                telephone: FormatPhone(telephone),
                idExternal: formMainUser?.id,
                cellPhoneAreaCode: formMainUser.cellPhoneAreaCode * 1,
                cellPhoneCharacteristic: formMainUser.cellPhoneCharacteristic,
                cellPhoneNumber: formMainUser.cellPhoneNumber,
                metadata: {
                    idStore,
                }
            };

            // Previous notification is canceled if possible
            if (notification?.id) {
                data.id = notification?.id;
            }

            data.delay = 650; // miliseconds

            const res = await retryService(() => asyncService((qs) => cuotitasStoreService.sendToken(data, qs)), 2, (r) => r, (e) => validProvider(e));

            setNotification(res?.notification);

            setIsTokenValidated(false);

            alert('success', 'SMS enviado correctamente.');

            // is used in ButtonSMS
            return true;
        }
        catch (error) {
            console.error('e: ', error);

            const dataError = getDataError(error);
            const msg = errorMapper(error);

            if (dataError?.error?.includes('is not a mobile number') || dataError?.error?.includes('Invalid telephone number')) {
                msg.type = 'warning';
                msg.message = 'Lo sentimos, el numero ingresado no es un numero de celular válido.';
            }

            // onClose Alert
            const onClose = () => setIsAllowContinue(true);
            alert(msg?.type, msg?.message, msg?.time, 'topCenter', () => submitToast(error), onClose);
            // is used in ButtonSMS
            setIsAllowContinue(false);
            return false;
        }
    };

    // helpers

    function validProvider (error) {
        const dataError = getDataError(error);
        return dataError?.error.includes('Provider could not send notification');
    };

    function getPostCode (value) {
        if (value) {
            const location = localities.find(location => location?.id === value);

            setTimeout(() => {
                formRef.current.checkForField('postcode');
            }, 500);

            return location?.codigoPostal || '';
        }
        return '';
    };

    function getStyleInput (name, style = {}) {
        try {
            return formErrorMainUser[name] ? { ...errorInput, ...style } : style;
        }
        catch (error) {
            return style;
        }
    };

    function scrollToPhoneOnError () {
        const formArray = Array.from(formRef.current.root);
        formArray.filter(e => e.value === formMainUser.cellPhoneCharacteristic)[0].scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    };

    // Events

    function onFormError (error = { value: 'message' }) {
        // scroll to element
        const getElement = Object.keys(error)[0];
        const element = document.getElementsByName(getElement);

        if (element.length) {
            element[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    function onChangeProvince () {
        // clean departament and locations
        if (formMainUser.department) {
            setFormMainUser((old) => ({ ...old, department: '', location: '', postcode: '' }));
        }
    };

    function onCleanProvince () {
        // Clean province, departament and locations
        setFormMainUser({
            ...formMainUser,
            province: '',
            department: '',
            location: '',
            postcode: ''
        });
    };

    function onChangeDepartment () {
        // Clean locations
        if (formMainUser.location) {
            setFormMainUser((old) => ({ ...old, location: '', postcode: '' }));
        }
    };

    function onCleanDepartament () {
        // Clean department and location
        setFormMainUser({
            ...formMainUser,
            department: '',
            location: '',
            postcode: ''
        });
    };

    return (
        <>
            <Modal.Body className='mb-5 h-100 py-1' style={{ height: '540px' }}>
                <div className='row m-0' style={body0} />
                <Form
                    fluid
                    formValue={formMainUser}
                    model={model}
                    onChange={setFormMainUser}
                    ref={formRef}
                    onCheck={setFormErrorMainUser}
                    onError={onFormError}
                >
                    <div className='row m-0' style={body0}>
                        <section className='mb-5'>
                            <h5>Información personal</h5>
                            <hr style={hr} />
                            <Grid fluid>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="firstName">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="firstName" label="Nombre" disabled />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} name="lastName">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="lastName" label="Apellido" disabled />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="document">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="document" label="DNI" disabled />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} name="gender">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="gender" label="Género" accepter={RadioGroup} disabled inline>
                                            <Radio value="m">Masculino</Radio>
                                            <Radio value="f">Femenino</Radio>
                                        </Field>
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="bornDate">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="bornDate" id="bornDate" label="Fecha de Nacimiento *"
                                            format="dd MM yyyy"
                                            accepter={DatePicker}
                                            block
                                            size='md'
                                            placeholder='Seleccione una fecha'
                                            limitEndYear={2019}
                                            placement='bottomEnd'
                                            renderValue={(value, format) => {
                                                if (!value) return '';
                                                return `${dateFns.format(value, 'dd/MM/y')}`;
                                            }}
                                            style={getStyleInput('bornDate')}
                                            error={formErrorMainUser.bornDate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="amount">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="amount" label="Ingreso mensual *"
                                            accepter={CurrencyField}
                                            placeholder="$ 150.000"
                                            decimalScale={0}
                                            value={formMainUser.amount}
                                            error={formErrorMainUser.amount}
                                            style={getStyleInput('amount')}
                                        />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} name="activity">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="activity" label="Actividad *"
                                            accepter={SelectPicker}
                                            data={activities}
                                            // style={{ width: '100%' }}
                                            error={formErrorMainUser.activity}
                                            style={getStyleInput('activity', { width: '100%' })}
                                            placement="topStart"
                                            placeholder="Seleccionar"
                                        />
                                    </Col>
                                </Row>
                            </Grid>
                        </section>
                        <section className='mb-5'>
                            <h5>Información de contacto</h5>
                            <hr style={hr} />
                            <Grid fluid>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="email">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="email" label="Email" />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} name="cellPhone">
                                        <CellPhoneField
                                            classNameGroup="mb-3"
                                            classNameLabel="font-weight-bold"
                                            name="cellPhone"
                                            ref={formRef}
                                            errorPlacement={errorPlacementData.bottomEnd}
                                            // error={formErrorMainUser.cellPhoneAreaCode || formErrorMainUser.cellPhoneCharacteristic || formErrorMainUser.cellPhoneNumber}
                                            // errorCellPhone={{
                                            //     cellPhoneAreaCode: formErrorMainUser.cellPhoneAreaCode,
                                            //     cellPhoneCharacteristic: formErrorMainUser.cellPhoneCharacteristic,
                                            //     cellPhoneNumber: formErrorMainUser.cellPhoneNumber
                                            // }}
                                            cellPhone={{
                                                code: formMainUser.cellPhoneAreaCode,
                                                characteristic: formMainUser.cellPhoneCharacteristic,
                                                number: formMainUser.cellPhoneNumber
                                            }}
                                            styleCellPhone={{
                                                cellPhoneAreaCode: getStyleInput('cellPhoneAreaCode'),
                                                cellPhoneCharacteristic: getStyleInput('cellPhoneCharacteristic'),
                                                cellPhoneNumber: getStyleInput('cellPhoneNumber'),
                                            }}
                                            label="Teléfono Celular *"
                                        />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="validateTelephone">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="validateTelephone" label="Codigo de validación celular *" style={getStyleInput('validateTelephone')} error={formErrorMainUser.validateTelephone} />
                                    </Col>
                                    <Col className="mt-7">
                                        <ButtonSMS sendSMS={sendOTP} timeDisable={'60'} description='Enviar codigo' id='sendOTP-GA' telephone={isDisabled} isAllowContinue={isAllowContinue} />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={12} name="additionalPhone">
                                        <PhoneField
                                            classNameGroup="mb-3"
                                            classNameLabel="font-weight-bold"
                                            name="additionalPhone"
                                            ref={formRef}
                                            phone={{
                                                code: formMainUser.additionalPhoneAreaCode,
                                                characteristic: formMainUser.additionalPhoneCharacteristic,
                                                number: formMainUser.additionalPhoneNumber
                                            }}
                                            label="Teléfono Alternativo"
                                        />
                                    </Col>
                                </Row>
                            </Grid>
                        </section>
                        <section className='mb-5'>
                            <h5>Información de domicilio</h5>
                            <hr style={hr} />
                            <Grid fluid>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="province">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="province" label="Provincia *"
                                            accepter={SelectPicker}
                                            data={provinces}
                                            valueKey="id"
                                            labelKey="descripcion"
                                            // style={{ width: '100%' }}
                                            style={getStyleInput('province', { width: '100%' })}
                                            error={formErrorMainUser.province}
                                            placement="topStart"
                                            placeholder="Seleccionar"
                                            onChange={() => onChangeProvince()}
                                            onClean={() => onCleanProvince()}
                                        />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} name="department">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="department" label="Partido *"
                                            accepter={SelectPicker}
                                            data={validDepartments}
                                            valueKey="id"
                                            labelKey="descripcion"
                                            // style={{ width: '100%' }}
                                            style={getStyleInput('department', { width: '100%' })}
                                            error={formErrorMainUser.department}
                                            placement="topStart"
                                            placeholder="Seleccionar"
                                            onChange={() => onChangeDepartment()}
                                            onClean={() => onCleanDepartament()}
                                        />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="location">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="location" label="Localidad *"
                                            accepter={SelectPicker}
                                            data={validLocalities}
                                            valueKey="id"
                                            labelKey="descripcion"
                                            // style={{ width: '100%' }}
                                            style={getStyleInput('location', { width: '100%' })}
                                            error={formErrorMainUser.location}
                                            placement="topStart"
                                            placeholder="Seleccionar"
                                            onChange={(value) => {
                                                if (value) {
                                                    setFormMainUser((old) => ({ ...old, location: value, postcode: getPostCode(value) }));
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} name="postcode">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="postcode" label="Código Postal *" style={getStyleInput('postcode')} error={formErrorMainUser.postcode} />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={18} name="street">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="street" label="Calle *" value={formMainUser.street} style={getStyleInput('street')} error={formErrorMainUser.street} />
                                    </Col>
                                    <Col xs={24} sm={24} md={6} name="number">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="number" label="Nro. *" value={formMainUser.number} style={getStyleInput('number')} error={formErrorMainUser.number} errorPlacement={errorPlacementData.bottomEnd} />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="floor">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="floor" label="Piso" value={formMainUser.floor} />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} name="apartment">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="apartment" label="Departamento" value={formMainUser.apartment} />
                                    </Col>
                                </Row>
                            </Grid>
                        </section>
                        <section className='mb-5'>
                            <h5>Información de referencia</h5>
                            <hr style={hr} />
                            <Grid fluid>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="reference-firstName">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="reference-firstName" label="Nombre *" style={getStyleInput('reference-firstName')} error={formErrorMainUser['reference-firstName']} />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} name="reference-lastName">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="reference-lastName" label="Apellido *" style={getStyleInput('reference-lastName')} error={formErrorMainUser['reference-lastName']} />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="reference-relation">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="reference-relation" label="Relación *" style={getStyleInput('reference-relation')} error={formErrorMainUser['reference-relation']} />
                                    </Col>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={24} sm={24} md={12} name="reference-phone">
                                        <PhoneField
                                            classNameGroup="mb-3"
                                            classNameLabel="font-weight-bold"
                                            name="reference-phone"
                                            ref={formRef}
                                            phone={{
                                                code: formMainUser['reference-phoneAreaCode'],
                                                characteristic: formMainUser['reference-phoneCharacteristic'],
                                                number: formMainUser['reference-phoneNumber']
                                            }}
                                            label="Teléfono *"
                                            // style={getStyleInput('reference-phone')}
                                            styleCellPhone={{
                                                cellPhoneAreaCode: getStyleInput('reference-phoneAreaCode'),
                                                cellPhoneCharacteristic: getStyleInput('reference-phoneCharacteristic'),
                                                cellPhoneNumber: getStyleInput('reference-phoneNumber'),
                                            }}
                                        // errorCellPhone={{
                                        //     cellPhoneAreaCode: formErrorMainUser['reference-phoneAreaCode'],
                                        //     cellPhoneCharacteristic: formErrorMainUser['reference-phoneCharacteristic'],
                                        //     cellPhoneNumber: formErrorMainUser['reference-phoneNumber']
                                        // }}
                                        />
                                    </Col>
                                    <Col name="reference-isCellPhone">
                                        <Field classNameGroup="mb-3" classNameLabel="font-weight-bold" name="reference-isCellPhone" label="¿Es celular? *" accepter={RadioGroup} inline style={getStyleInput('reference-isCellPhone')} error={formErrorMainUser['reference-isCellPhone']}>
                                            <Radio value={true}>Sí</Radio>
                                            <Radio value={false}>No</Radio>
                                        </Field>
                                    </Col>
                                </Row>
                            </Grid>
                        </section>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div>
                    <Button appearance='subtle' id='back_btn' disabled={isLoading || !isAllowBack} onClick={() => back()} >Atrás</Button>
                    <Button appearance='primary' id='fourth_forward' disabled={isLoading || !isAllowContinue} onClick={() => submit()} >Siguiente</Button>
                </div>
            </Modal.Footer>
        </>
    );
};
